<!--  -->
<template>
  <div>
    <footer class="footer-1" :style="$route.path=='/'?'':'padding: 69px 0 0;'">
    <div class="container">
        <div class="row" v-if="$route.path=='/'">
            <div class="col-md-12">
                <div class="cta-wrapper">
                    <img src="/static/images/home/2.png" alt="">
                    <h3>在我们的帮助下，你可以成为自己的指路明灯！</h3>
                    <router-link to="/mycourses" class="bisylms-btn">立即学习</router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-3">
                <aside class="widget">
                    <div class="about-widget">
                        <router-link to="/"><img src="/static/images/ZGY_hx_h_n.png" alt=""></router-link>
                        <!-- <p>
                            Lost the plot Richard you mug cup of tea knackered boot bender.
                        </p> -->
                        <p>联系方式：<a :href="`tel:${webConfig.phone}`">{{webConfig.phone}}</a></p>
                        <p>联系邮箱：<a :href="`mailto:${webConfig.email}`" class="mail">{{webConfig.email}}</a></p>
                        <p>地址：{{webConfig.address}}</p>
                        <p>技术支持：<a href="http://www.beijsci.com">北捷科技</a></p>
                        <!-- <div class="ab-social">
                            <a class="fac" href="#"><i class="social_facebook"></i></a>
                            <a class="twi" href="#"><i class="social_twitter"></i></a>
                            <a class="you" href="#"><i class="social_youtube"></i></a>
                            <a class="lin" href="#"><i class="social_linkedin"></i></a>
                        </div> -->
                    </div>
                </aside>
            </div>
            <div class="col-lg-3 col-md-3">
                <aside class="widget" v-if="web_links.length>0">
                    <h3 class="widget-title">友情链接</h3>
                    <ul>
                        <li  v-for="(weblink,index) in web_links" :key="index"><a :href="weblink.url" target="_blank">{{weblink.name}}</a></li>
                    </ul>
                </aside>
            </div>
            <div class="col-lg-3 col-md-3">
                <aside class="widget">
                    <h3 class="widget-title">网站导肮</h3>
                    <ul>
                        <li><router-link to="/">首页</router-link></li>
                        <li><router-link to="/courviews">选课中心</router-link></li>
                        <li><router-link to="/papercenter">考试中心</router-link></li>
                        <li><router-link to="/liveview">直播中心</router-link></li>
                        <li><router-link to="/personcenter">个人中心</router-link></li>
                    </ul>
                </aside>
            </div>
            <div class="col-lg-2 col-md-3">
                <aside class="widget">
                    <h3 class="widget-title" style="text-align: center;">考试平台</h3>
                    <ul>
                        <img src="/static/images/erweima.png" style="width: 100%;"/>
                    </ul>
                </aside>
            </div>
        </div>
        <!-- Copyrigh -->
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="copyright">
                    <p>© 2021 Copyright all Right Reserved Design by <a href="https://www.cyrzpx.org.cn">www.cyrzpx.org.cn</a></p>
                </div>
            </div>
        </div>
        <!-- Copyrigh -->
    </div>
</footer>
<!-- Footer Section End -->

  </div>
</template>

<script>
export default {
  data () {
    return {
        webConfig:{},
        web_links:[]
    };
  },

  components: {},

  computed: {},

  mounted(){
    this.$axios.get("/api/webConfigs").then(res => {
        if(res.data&&res.data.data.length>0)
        {
            this.webConfig = res.data.data[0];
        }
    }); 
    this.$axios.get("/api/links?&sort=-createdAt").then((res) => {
      if (res.data) {
        this.web_links = res.data.data;
      }
    })
  },

  methods: {}
}

</script>
<style scoped>
</style>